import PropTypes from "prop-types";
import classNames from "classnames";
import { useState } from "react";
import SinglePageAppLink from "../../../../components/SinglePageAppLink";
import { withTranslation } from "../../../../components/translation";
import { SEE_ALL_TRANSLATION_KEY } from "../../stores/category/selectors/getCategoryVisualCategories";
import styles from "./VisualCategoryTile.css";

export const VisualCategoryTile = ({
  id,
  name,
  imageUrl,
  linkUrl,
  isSelected,
  isSeeAll,
  onSelect,
  formatTranslation
}) => {
  const [hasImageError, setHasImageError] = useState(false);
  const displayName = isSeeAll
    ? formatTranslation(SEE_ALL_TRANSLATION_KEY)
    : name;

  return (
    <li
      className={styles.tile}
      data-visual-category-selected={isSelected ? "true" : "false"}
    >
      <SinglePageAppLink
        href={linkUrl}
        className={classNames(styles.link, {
          [styles.linkSelected]: isSelected
        })}
        onClick={() => onSelect(id)}
      >
        <div
          className={styles.imageWrapper}
          data-testid="visual-category-image-wrapper"
        >
          {!hasImageError && (
            <img
              src={imageUrl}
              alt={displayName}
              className={styles.image}
              loading="lazy"
              onError={() => setHasImageError(true)}
            />
          )}
        </div>
        <p
          className={classNames(styles.name, {
            [styles.nameSelected]: isSelected
          })}
        >
          {displayName}
        </p>
      </SinglePageAppLink>
    </li>
  );
};

VisualCategoryTile.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  isSeeAll: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(VisualCategoryTile);
